var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8265 11.6661L6.7793 7.61889L2.73208 11.6661C2.28689 12.1113 1.55839 12.1113 1.11319 11.6661C0.667998 11.2209 0.667998 10.4924 1.11319 10.0472L5.16041 6L1.11319 1.95278C0.667998 1.50759 0.667998 0.779089 1.11319 0.333895C1.55839 -0.111298 2.28689 -0.111298 2.73208 0.333895L6.7793 4.38111L10.8265 0.333895C11.2717 -0.111298 12.0002 -0.111298 12.4454 0.333895C12.8906 0.779089 12.8906 1.50759 12.4454 1.95278L8.39818 6L12.4454 10.0472C12.8906 10.4924 12.8906 11.2209 12.4454 11.6661C12.0002 12.1113 11.2717 12.1113 10.8265 11.6661Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8a3debf4207e734bc67a72c9aa28517f.svg";
export { ForwardRef as ReactComponent };